import React from "react";
import { Button, dialog, printComponent } from "../../../nq-component";
import {
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import BaseFormPage from "../../../base/BaseFormPage";
import FormFactory from "../../../components/FormFactory";
import { json, Link, Navigate } from "react-router-dom";
import schemaContactPerson from "./schemas/schemaContactPerson.json";
import schemaPersonalForm1 from "./schemas/schemaPersonalForm1.json";
import schemaPersonalForm2 from "./schemas/schemaPersonalForm2.json";
import schemaIdForm from "./schemas/schemaIdForm.json";
import schemaEmployment from "./schemas/schemaEmployment.json";
import schemaCharacterRef from "./schemas/schemaCharacterRef.json";
import schemaElementaryForm from "./schemas/schemaElementaryForm.json";
import schemaHSForm from "./schemas/schemaHSForm.json";
import schemaColForm from "./schemas/schemaColForm.json";
import schemaDocForm from "./schemas/schemaDocForm.json";
import schemaPresentAddress from "./schemas/schemaPresentAddress.json";
import schemaOtherDocs from "./schemas/schemaOtherDocs.json";
import schemaPermanentAddress from "./schemas/schemaPermanentAddress.json";
import InputFactory from "../../../components/InputFactory";
import NavBar from "../../../components/navbar";
import DialogWarning from "./components/DialogWarning";
import DialogInterviewForm from "./components/DialogInterviewForm";
import DialogAssignCoordinator from "./components/DialogAssignCoordinator";
import DialogSuccess from "./components/DialogSuccess";
import DialogSchedule from "./components/DialogSchedule";
import DialogConfirmation from "./components/DialogConfirmation";
import DialogOnboard from "./components/DialogOnboard";
import { saveFileUseCase, saveImageUseCase } from "../../../usecases/file";
import RelationForm from "../../../components/RelationForm";
import DialogRemarks from "./components/DialogRemarks";
import ApplicantBoardingFormPresenter from "./ApplicantBoardingFormPresenter";
import DialogHired from "./components/DialogHired";
import ConsentPrint from "./components/ConsentPrint";
import { auditUseCase } from "../../../usecases/audit";

class ApplicantBoardingFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      positions: [],
      selectedPosition: "",
      locations: [],
      clients: [],
      onBoards: [],
      location: "",
      coordinators: [],
      coordinatorId: "",
      isAddressSame: false,
      recruiters: [],
      remarks: "",
      age: 0,
      image: "",
      employers: [{ id: crypto.randomUUID() }],
      characterref: [{ id: crypto.randomUUID() }],
    };
    this.presenter = new ApplicantBoardingFormPresenter(
      this,
      upsertUseCase(),
      getObjectUseCase(),
      findObjectUseCase(),
      deleteObjectUseCase(),
      auditUseCase(),
    );

    this.consentPDF = React.createRef();
  }

  componentDidMount() {
    this.getJobPositions();
    this.presenter.componentDidMount();
  }

  componentWillUnmount() {
    sessionStorage.removeItem("interviewDatasOnline");
  }

  getCollectionName() {
    const typeOfApplication = this.getApplicationType();
    switch (typeOfApplication) {
      case "online":
        return "online_applicants";
        break;
      case "walkIn":
        return "walkIn_applicants";
        break;
      default:
        return "reprocess_applicants";
        break;
    }
  }

  getApplicationType() {
    return this.props.params.type;
  }

  isOnBoardComplete() {
    return this.props.params.status;
  }

  handleBackToPoll() {
    dialog.close();
    this.presenter.handleBackToPoll();
  }

  navigateToForm() {
    this.presenter.navigateToForm();
  }

  getLocations() {
    this.presenter.getLocations();
  }

  getCoordinators(location) {
    this.presenter.getCoordinators(location);
  }

  showDialogWarning(message) {
    dialog.fire({
      html: <DialogWarning message={message} />,
      footer: false,
    });
    return null;
  }

  onChangeRemarks(event) {
    const value = event.target.value;
    this.setState({ remarks: value }, () => {
      console.log(this.state.remarks);
    });
  }

  successModal(message) {
    dialog.fire({
      html: <DialogSuccess message={message} />,
      footer: false,
    });
  }

  goBack() {
    window.history.back();
  }

  viewOrientationForm() {
    const { object } = this.state;
    this.navigateTo(
      `/onboarding/applicant/orientation-form/${object?.interviewCoordinator}/${object?.id}`,
    );
  }

  onClickPrint() {
    this.presenter.onClickPrint();
  }

  exportPDF() {
    printComponent(this.consentPDF.current);
  }

  listButton() {
    const { object } = this.state;
    const user = this.getCurrentUser();
    const role = user?.roles[0]?.id;

    switch (object.status) {
      case "On-boarding":
        return (
          <>
            <div className="d-flex gap-2">
              <button
                className="btn text-white fw-bold"
                style={{
                  backgroundColor: !object?.startDate ? "#3174ad7d" : "#3174ad",
                }}
                onClick={this.onClickPrint.bind(this)}
                disabled={!object?.startDate}
              >
                <i class="bi bi-printer me-2"></i>
                Print Endorsement Form
              </button>{" "}
              <button
                className="btn text-white"
                style={{
                  backgroundColor: !object.termsAgreed
                    ? "#d1823799"
                    : "#d18237",
                }}
                onClick={this.viewOrientationForm.bind(this)}
                disabled={!object.termsAgreed}
              >
                <i className="bi bi-eye me-2"></i>
                View Orientation Form
              </button>
              <button
                className="btn text-white"
                style={{
                  backgroundColor: !object.termsAgreed
                    ? "#28a74585"
                    : "#28a745",
                }}
                onClick={this.handleHiredSubmit.bind(this)}
                disabled={!object.termsAgreed}
              >
                <i className="bi bi-check-circle me-2"></i>
                Hired
              </button>
              <button
                className="btn text-white"
                style={{ backgroundColor: "#dc3545" }}
                onClick={this.onClickNotHire.bind(this)}
              >
                <i className="bi bi-x-circle me-2"></i>
                Not Hired
              </button>
            </div>
          </>
        );
        break;
      case "Hired":
        return (
          <div className="d-flex gap-2">
            <button
              className="btn text-white fw-bold"
              style={{
                backgroundColor: !object?.startDate ? "#3174ad7d" : "#3174ad",
              }}
              onClick={this.onClickPrint.bind(this)}
              disabled={!object?.startDate}
            >
              <i class="bi bi-printer me-2"></i>
              Print Endorsement Form
            </button>{" "}
            <button
              className="btn text-white"
              style={{
                backgroundColor: !object.termsAgreed ? "#d1823799" : "#d18237",
              }}
              onClick={this.viewOrientationForm.bind(this)}
              disabled={!object.termsAgreed}
            >
              <i className="bi bi-eye me-2"></i>
              View Orientation Form
            </button>
          </div>
        );
        break;
      default:
        return "";
        break;
    }
  }

  formSubmit(e) {
    e.preventDefault();

    this.presenter.submitForm();
  }

  showModal(title, message) {
    dialog.fire({
      html: <DialogWarning title={title} message={message} />,
      footer: false,
    });
  }

  onChangePersonal(value, field) {
    this.presenter.onChangePersonal(value, field);

    switch (field) {
      case "birthDate":
        const today = new Date();
        const birthDate = new Date(value);
        const age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();

        const calculatedAge =
          monthDifference < 0 ||
          (monthDifference === 0 && today.getDate() < birthDate.getDate())
            ? age - 1
            : age;

        if (calculatedAge < 0) {
          this.showModal(
            "Invalid Birth Date",
            "The birth date you entered is in the future. Please enter a valid birth date.",
          );
          return;
        }

        this.setState({ age: calculatedAge });
        this.presenter.onChangePersonal(calculatedAge, "age");
        break;
      default:
        break;
    }
  }

  addEmployer = () => {
    this.setState((prevState) => ({
      object: {
        ...prevState.object,
        employmentBackground: [
          ...(prevState.object.employmentBackground || []),
          { id: crypto.randomUUID() },
        ],
      },
    }));
  };

  addCharacterRef = () => {
    this.setState((prevState) => ({
      object: {
        ...prevState.object,
        characterReferences: [
          ...(prevState.object.characterReferences || []),
          { id: crypto.randomUUID() },
        ],
      },
    }));
  };

  removeEmployer = (id) => {
    if (this.state.object.employmentBackground.length > 1) {
      this.setState((prevState) => ({
        object: {
          ...prevState.object,
          employmentBackground: prevState.object.employmentBackground.filter(
            (employer) => employer.id !== id,
          ),
        },
      }));
      this.presenter.removeEmployment(id);
      console.log(this.state.object.employmentBackground);
      console.log(id);
    }
  };

  removeCharacterRef = (id) => {
    this.setState((prevState) => ({
      object: {
        ...prevState.object,
        characterReferences: prevState.object.characterReferences.filter(
          (character) => character.id !== id,
        ),
      },
    }));
    this.presenter.removeCharacterRef(id);
    console.log(this.state.object.characterReferences);
    console.log(id);
  };
  onChangeLGS(value, field) {
    this.setState({ whereLGSSee: value });
    this.presenter.onChangePersonal(value, field);
  }
  onChangeRecruiter(event) {
    this.presenter.onChangeRecruiter(event);
  }

  toggleCheckbox(event) {
    const isChecked = event.target.checked;
    this.setState({ isAddressSame: isChecked });
  }

  onUpdateSubmit() {
    this.presenter.onUpdate();
  }

  viewFile(fileUrl) {
    window.open(fileUrl, "_blank");
  }

  handleClickHireSubmit(endDateTime, employmentStatus, department) {
    const { object } = this.state;
    this.presenter.handleClickHireApplicant(
      object,
      endDateTime,
      employmentStatus,
      department,
    );
  }

  handleHiredSubmit() {
    const { object } = this.state;
    // console.log(object);
    // const requiredDocs = [
    //   "diploma",
    //   "tor",
    //   "reportCard",
    //   "coe",
    //   "trainingCertificate",
    // ];

    // const missingDocs = requiredDocs.filter((doc) => !object?.[doc]);
    // const formatCamelCase = (str) =>
    //   str
    //     .replace(/([A-Z])/g, " $1")
    //     .replace(/^./, (char) => char.toUpperCase());

    // if (missingDocs.length > 0) {
    //   const formatted = missingDocs.map(formatCamelCase).join(", ");
    //   this.showDialogWarning(`Missing required document(s): ${formatted}`);
    //   return;
    // }

    dialog.fire({
      html: (
        <DialogHired
          object={object}
          handleSubmit={this.handleClickHireSubmit.bind(this)}
        />
      ),
      footer: false,
    });
  }

  onNotHire() {
    const { object } = this.state;
    dialog.close();
    this.presenter.onNotHire(object);
  }

  onClickNotHire() {
    dialog.fire({
      html: <DialogConfirmation handleAssign={this.onNotHire.bind(this)} />,
      footer: false,
    });
  }

  showSuccess(message) {
    dialog.fire({
      html: <DialogSuccess message={message} />,
      footer: false,
    });
  }

  getJobPositions() {
    this.presenter.getJobPositions();
  }

  render() {
    const {
      object,
      whereLGSSee,
      // location,
      // coordinators,
      // coordinatorId,
      // employers,
      image,
      onBoards,
      isAddressSame,
      recruiters,
      age,
      positions,
      clients,
    } = this.state;
    const user = this.getCurrentUser();
    console.log(clients);
    // const positionOptions = Array.isArray(object.positionDesired)
    //   ? object.positionDesired.map((position) => position.positionTitle)
    //   : [];

    const positionOptions = Array.isArray(positions)
      ? positions.map((position) => position.positionTitle)
      : [];

    const role = user.roles[0].id;
    const onboardStatus = this.isOnBoardComplete();
    const status =
      onboardStatus === "true" || object?.recruiter?.id !== user?.id;

    // const isAddressSame =
    //   object.permanent_barangay === object.present_barangay &&
    //   object.permanent_city === object.present_city &&
    //   object.permanent_houseNumber === object.present_houseNumber &&
    //   object.permanent_province === object.present_province &&
    //   object.permanent_street === object.present_street &&
    //   object.permanent_subdivision === object.present_subdivision &&
    //   object.permanent_zipCode === object.present_zipCode &&
    //   object.telephone === object.present_telephone;
    switch (status) {
      case true:
        schemaPersonalForm1.fields.sex._type = "String";
        schemaPersonalForm2.fields.family_order._type = "String";
        schemaPersonalForm2.fields.bloodType._type = "String";
        break;
      default:
        schemaPersonalForm1.fields.sex._type = "Enum";
        schemaPersonalForm2.fields.family_order._type = "Enum";
        schemaPersonalForm2.fields.bloodType._type = "Enum";
        break;
    }

    return (
      <>
        <div className="d-none">
          <div ref={this.consentPDF}>
            <ConsentPrint object={object} />
          </div>
        </div>
        <NavBar user={user} />
        <div>
          <div className="p-4 overflow-auto">
            <div className="d-flex gap-4 justify-content-between">
              <div className="d-flex">
                <h1 className="fw-bold fs-4">
                  <div className="d-flex gap-3 mb-3 align-items-center">
                    <div
                      className="rounded-5 p-1 cursor-pointer"
                      style={{ backgroundColor: `#E6E6E6` }}
                      onClick={this.goBack.bind(this)}
                    >
                      <i
                        class="bi bi-arrow-left-short"
                        style={{ width: `1rem`, height: `1rem` }}
                      ></i>
                    </div>
                    <span style={{ color: `#D18237` }}>Application Form</span>
                  </div>
                </h1>
              </div>

              <div>
                {role === "Recruiter" || role === "Coordinator"
                  ? this.listButton()
                  : ""}
              </div>
            </div>
            {object?.remarks ? (
              <div className="bg-white p-4 rounded-3 mt-3 border border-1 border-danger">
                <h6
                  className="text-uppercase fw-bold mb-3 text-danger"
                  style={{ color: "#D18237" }}
                >
                  Rejected by Coordinator
                </h6>
                <div
                  className="d-flex flex-column gap-2"
                  style={{ fontSize: "0.9rem" }}
                >
                  <div className="d-flex gap-2">
                    <span className="fw-bold text-muted">Remarks:</span>
                    <span className="text-dark">
                      {object?.remarks || "No remarks available"}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            <div className="d-flex flex-column">
              <div className="bg-white mt-4 p-4 rounded-3 d-flex flex-column gap-0">
                <div className="d-flex justify-content-between">
                  <div>
                    <p className="fs-5 fw-bold p-0 m-0">Instructions:</p>
                    <p className="p-0 m-0">
                      1. Answer ALL questions completely and accurately.
                    </p>
                    <p className="p-0 m-0">
                      2. This must be filled-out in your OWN handwriting.
                    </p>
                  </div>
                  <div>
                    <div className="d-flex gap-2 mt-4">
                      {role === "Recruiter" || role === "Coordinator" ? (
                        <button
                          disabled={status}
                          type="submit"
                          className="p-2 text-white rounded-1 border-0 fw-bold px-4"
                          style={{
                            backgroundColor: status ? `#d1823775` : `#D18237`,
                          }}
                          onClick={this.onUpdateSubmit.bind(this)}
                        >
                          Update Application
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <div className="d-flex flex-column justify-content-md-start mt-3 gap-2">
                    <div className="d-flex flex-column gap-2">
                      <b>Where did you see LGS?</b>
                      <InputFactory
                        type={status === true ? "String" : "Enum"}
                        disabled={status === true}
                        required
                        options={[
                          "Walk-in",
                          "Social Media",
                          // "Recruiter",
                          "Word of Mouth",
                        ]}
                        className="form-control bg-light-subtle p-2"
                        placeholder="Select"
                        field="seeLGS"
                        defaultValue={object.seeLGS}
                        onChange={this.onChangeLGS.bind(this)}
                      />
                      {whereLGSSee === "Recruiter" ? (
                        <div>
                          <select
                            className="form-control bg-light-subtle p-2"
                            onChange={this.onChangeRecruiter.bind(this)}
                          >
                            <option selected>Select Recruiter</option>
                            {recruiters.map((recruiter, index) => (
                              <option key={index} value={recruiter?.id}>
                                {recruiter.employee?.firstName +
                                  ` ${recruiter.employee?.lastName}`}
                              </option>
                            ))}
                          </select>
                        </div>
                      ) : (
                        <div className="d-flex flex-column">
                          <p className="text-muted m-0 p-0">
                            Position/s Applied for:
                          </p>

                          <InputFactory
                            type={status === true ? "String" : "Enum"}
                            disabled={status === true}
                            options={positionOptions}
                            required
                            className="form-control bg-light-subtle p-2"
                            placeholder="Select"
                            field="positionApplied"
                            defaultValue={object.positionApplied}
                            onChange={this.onChangePersonal.bind(this)}
                          />
                        </div>
                      )}
                    </div>
                    <div className="mt-2">
                      <b>Do you have any relative in:</b>
                      <div className="mt-2">
                        <label className="form-label fs-sm">LGS</label>
                        <InputFactory
                          type={status === true ? "String" : "Enum"}
                          disabled={status === true}
                          options={["Yes", "No"]}
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Select"
                          field="relativeLGS"
                          defaultValue={object.relativeLGS}
                          onChange={this.onChangePersonal.bind(this)}
                        />
                      </div>
                      <div>
                        <label className="form-label fs-sm">Client</label>
                        <InputFactory
                          type={status === true ? "String" : "Enum"}
                          disabled={status === true}
                          options={["Yes", "No"]}
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Select"
                          field="relativeClient"
                          defaultValue={object.relativeClient}
                          onChange={this.onChangePersonal.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex gap-3 mt-3 col-lg-8">
                    <div className="d-flex flex-column align-items-center">
                      <label className="fw-bold">
                        Image 1
                        <span className="text-danger fw-lighter ms-1">*</span>
                      </label>
                      {object?.image1 ? (
                        <div
                          className="border-1 border rounded-3 position-relative col-sm-6"
                          style={{ width: "300px", height: "300px" }}
                        >
                          <img
                            className="w-100 h-100 rounded-1 object-fit-contain"
                            src={`${object?.image1}`}
                            alt="Uploaded file"
                            style={{ objectFit: "cover" }}
                          />
                          <button
                            className="btn btn-sm bg-white position-absolute"
                            onClick={() => this.viewFile(object?.image1)}
                            style={{ top: `2%`, right: `2%` }}
                          >
                            <i class="bi bi-eye text-success"></i>
                          </button>
                        </div>
                      ) : (
                        <div
                          className="border-1 border rounded-3 position-relative col-sm-6 bg-light-subtle"
                          style={{ width: "300px", height: "300px" }}
                        >
                          <a href="#uploadImage">
                            <img
                              className="w-100 h-100"
                              src="/defaultImage.png"
                              alt="Default Image"
                              style={{ objectFit: "cover" }}
                            />
                          </a>
                        </div>
                      )}
                    </div>

                    <div className="d-flex flex-column align-items-center">
                      <label className="fw-bold">
                        Image 2
                        <span className="text-danger fw-lighter ms-1">*</span>
                      </label>
                      {image || object?.image2 ? (
                        <div
                          className="border-1 border rounded-3 position-relative col-sm-6"
                          style={{ width: "300px", height: "300px" }}
                        >
                          <img
                            className="w-100 h-100 rounded-1 object-fit-contain"
                            src={`${image || object?.image2}`}
                            alt="Uploaded file"
                            style={{ objectFit: "cover" }}
                          />
                          <button
                            className="btn btn-sm bg-white position-absolute"
                            onClick={() =>
                              this.viewFile(image || object?.image2)
                            }
                            style={{ top: `2%`, right: `2%` }}
                          >
                            <i className="bi bi-eye text-success fw-bold"></i>
                          </button>
                        </div>
                      ) : (
                        <div
                          className="border-1 border rounded-3 position-relative col-sm-6 bg-light-subtle"
                          style={{ width: "300px", height: "300px" }}
                        >
                          <a href="#uploadImage">
                            <img
                              className="w-100 h-100"
                              src="/defaultImage.png"
                              alt="Default Image"
                              style={{ objectFit: "cover" }}
                            />
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mt-5">
                  <b>Personal Information</b>
                  <hr />
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    disabled={status === true}
                    schema={schemaPersonalForm1}
                    object={object}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                  <span
                    className="d-inline-block col-md-2 col-lg-1"
                    style={{ marginTop: `1rem` }}
                  >
                    <small>
                      Age<span className="text-danger ms-1">*</span>
                    </small>
                    <p
                      className="bg-light-subtle p-2 cursor-pointer text-center fw-bold border border-1 rounded-1"
                      style={{ marginTop: `0.5rem` }}
                    >
                      {age || object.age}
                    </p>
                  </span>
                  <FormFactory
                    disabled={status === true}
                    schema={schemaPersonalForm2}
                    object={object}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>

                <div className="row justify-content-md-start mt-3">
                  <div className="mt-4">
                    <b>Present Address</b>
                  </div>
                  <FormFactory
                    disabled={status === true}
                    schema={schemaPresentAddress}
                    object={object}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>
                <div className="row justify-content-md-start mt-3">
                  <div className="col-md-5 d-flex gap-2">
                    <input
                      type="checkbox"
                      disabled={status === true}
                      onChange={this.toggleCheckbox.bind(this)}
                      className="cursor-pointer"
                    />
                    <p className="m-0 p-0">
                      Permanent Address same as a Present Address
                    </p>
                  </div>
                </div>

                {!isAddressSame ? (
                  <div className="row justify-content-md-start mt-3">
                    <div className="mt-4">
                      <b>Permanent Address</b>
                    </div>
                    <FormFactory
                      disabled={status === true}
                      schema={schemaPermanentAddress}
                      object={object}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  </div>
                ) : (
                  ""
                )}

                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    disabled={status === true}
                    schema={schemaIdForm}
                    object={object}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>
                <div className="mt-4">
                  <b>Emergency Contact Person</b>
                  <hr></hr>
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    disabled={status === true}
                    schema={schemaContactPerson}
                    object={object}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>
                <div className="mt-4">
                  <b>Educational Information</b>
                  <hr />
                </div>
                <div className="mt-4">
                  <b>Elementary</b>
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    disabled={status === true}
                    schema={schemaElementaryForm}
                    object={object}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>

                <div className="mt-4">
                  <b>High School</b>
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    disabled={status === true}
                    schema={schemaHSForm}
                    object={object}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>
                <div className="mt-4">
                  <b>College</b>
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    disabled={status === true}
                    schema={schemaColForm}
                    object={object}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>

                <div className="row justify-content-md-start mt-3">
                  <div className="col-md-5 d-flex">
                    <InputFactory
                      disabled={status === true}
                      type="Boolean"
                      field="isFreshGrad"
                      label="Fresh Graduate"
                      object={object}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  </div>
                </div>
                <div>
                  {status === true ? (
                    <>
                      <div className="mt-3">
                        <b>Employment Background</b>
                        <hr />
                      </div>

                      <div className="row justify-content-md-start mt-3">
                        {object.employmentBackground?.map(
                          (employment, index) => (
                            <FormFactory
                              schema={schemaEmployment}
                              object={employment}
                              disabled
                            />
                          ),
                        )}
                      </div>
                    </>
                  ) : (
                    <RelationForm
                      title="Employment Background"
                      schema={schemaEmployment}
                      objects={object?.employmentBackground}
                      object={object}
                      onChangeForm={this.presenter.onChangeEmployment}
                      addForm={this.addEmployer}
                      remove={this.removeEmployer}
                      field="employmentBackground"
                    />
                  )}
                </div>
                <div>
                  {status === true ? (
                    <>
                      <div className="mt-3">
                        <b>Character References</b>
                        <hr />
                      </div>
                      <div className="row justify-content-md-start mt-3">
                        {object.characterReferences?.map((reference, index) => (
                          <FormFactory
                            schema={schemaCharacterRef}
                            disabled
                            object={reference}
                          />
                        ))}
                      </div>
                    </>
                  ) : (
                    <RelationForm
                      title="Character References"
                      schema={schemaCharacterRef}
                      objects={object?.characterReferences}
                      object={object}
                      onChangeForm={this.presenter.onChangecharacteref}
                      addForm={this.addCharacterRef}
                      remove={this.removeCharacterRef}
                      field="characterReferences"
                    />
                  )}

                  {/* <InputFactory
                    type="Relation"
                    schema={schemaCharacterRef}
                    object={object}
                    objects={object?.characterReferences}
                    field="characterReferences"
                    schemas={schemas}
                  /> */}
                </div>

                <div className="mt-4">
                  <b>School Record</b>
                  <hr />
                </div>

                <div className="d-flex flex-row justify-content-md-start mt-3 gap-3">
                  {
                    <div className="col-lg-3">
                      <label>Diploma</label>
                      <InputFactory
                        type="String"
                        disabled={status === true}
                        _type="File"
                        required
                        className="form-control bg-light-subtle p-2"
                        placeholder="Diploma"
                        field="diploma"
                        object={object}
                        onChange={this.onChangePersonal.bind(this)}
                      />
                    </div>
                  }
                  {
                    <div className="col-lg-3">
                      <label>TOR</label>
                      <InputFactory
                        type="String"
                        disabled={status === true}
                        _type="File"
                        required
                        className="form-control bg-light-subtle p-2"
                        placeholder="TOR"
                        field="tor"
                        object={object}
                        onChange={this.onChangePersonal.bind(this)}
                      />
                    </div>
                  }
                  {
                    <div className="col-lg-3">
                      <label>Report Card</label>
                      <InputFactory
                        type="String"
                        disabled={status === true}
                        _type="File"
                        required
                        className="form-control bg-light-subtle p-2"
                        placeholder="Report Card"
                        field="reportCard"
                        object={object}
                        onChange={this.onChangePersonal.bind(this)}
                      />
                    </div>
                  }
                  {
                    <div className="col-lg-3">
                      <label>Graduation Certificate</label>
                      <InputFactory
                        type="String"
                        disabled={status === true}
                        _type="File"
                        required
                        className="form-control bg-light-subtle p-2"
                        placeholder="Graduation Certificate"
                        field="graduationCertificate"
                        object={object}
                        onChange={this.onChangePersonal.bind(this)}
                      />
                    </div>
                  }
                </div>
                <div className="mt-4">
                  <b>Upload Documents</b>
                  <hr />
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    disabled={status === true}
                    schema={schemaDocForm}
                    object={object}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    disabled={status === true}
                    schema={schemaOtherDocs}
                    object={object}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ApplicantBoardingFormPage);
